/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Support_AInputs */

const en_wc_faq_support_a = /** @type {(inputs: Wc_Faq_Support_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email support@wordcraftapp.com for questions about our guides, broken download links, tutorials, comparisons or access to the hosted online editor. Include the page URL and relevant browser or operating-system details. Software development requests belong with the WordCraft developers.`)
};

/**
* | output |
* | --- |
* | "Email support@wordcraftapp.com for questions about our guides, broken download links, tutorials, comparisons or access to the hosted online editor. Include t..." |
*
* @param {Wc_Faq_Support_AInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_support_a = /** @type {((inputs?: Wc_Faq_Support_AInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Support_AInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_support_a(inputs)
});
export { wc_faq_support_a as "wc.faq.support.a" }